import styled from 'styled-components';

export const Grid = styled.div`
  --card-w: 84px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--card-w), 1fr));
  gap: 12px;
  justify-items: center;
`;

export const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
`;
